import { app } from '../../../../../app';
import { Controller } from './add-epm.controller';

app.component('companyAddEpm', {
    bindings: {
        companyId: '<',
        publicService: '<',
    },
    controller: Controller,
    templateUrl: require('./add-epm.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-applications/supported-epm-types/add/add-epm.component.js